export default __webpack_public_path__ + "static/media/paper22.7b3edea6.JPG";